import { propertySubtitle } from "web_myplann/Portfolio/Components/Redesign/ListItem/propertyHelpers";
import type { CategoryItem } from "web_myplann/Portfolio/Types/portfolioCategory";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

export const categoryItemSubtitle = (item: CategoryItem): string =>
	item.kind === PortfolioItemKind.Property
		? propertySubtitle(item.data)
		: (item.data.producer ?? "");
